import {FILECOMMAND, SELECTMENU, CURRENTUSER, TESTREPORT, CURRENTLESSON, UPLOADCODE,EXPANDPREVIEWCODE,CANCELMENU,ISPRIVACY,ISEYE,HASOLDENTRANCE,PLAYFLAG,TOKEN} from './types';
export default {
    [TOKEN](state, value){
        state[TOKEN]= value;
    },
    [FILECOMMAND](state, value){
        state.fileCommand = value;
    },
    [SELECTMENU](state, value){
        state.selectMenu = value;
    },
    [CURRENTUSER](state, value){
        state.currentUser = value;
    },
    [TESTREPORT](state, value){
        state.testReport = value;
    },
    [CURRENTLESSON](state, value){
        state.currentLesson = value;
    },
    [UPLOADCODE](state, value) {
        state.uploadCode = value;
    },
    [EXPANDPREVIEWCODE](state, value) {
        state.expandPreviewCode = value;
    },
    [CANCELMENU] (state, value) {
        state.cancelMenu = value;
    },
    [ISPRIVACY](state,value) {
        state.isPrivacy = value;
    },
    [ISEYE](state,value) {
        state.isEye = value;
    },
    [HASOLDENTRANCE](state,value) {
        state.hasOldEntrance = value;
    },
    [PLAYFLAG](state,value) {
        state.playFlag = value;
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js